import { render, staticRenderFns } from "./Followup_Feedback.vue?vue&type=template&id=caf9ad52"
import script from "./Followup_Feedback.vue?vue&type=script&lang=js"
export * from "./Followup_Feedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports